var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 10,
    viewBox: "0 0 15 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".mailIcon{fill:currentColor;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3 -49.693)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 49.693)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "mailIcon",
    d: "M10.1,976.362a1.05,1.05,0,0,0-.583.18l6.494,5.775a.722.722,0,0,0,.995,0l6.482-5.775a1.05,1.05,0,0,0-.583-.18Zm-1.035.775a1.2,1.2,0,0,0-.063.379v7.692a1.187,1.187,0,0,0,.177.625l4.647-4.453Zm14.874,0-4.75,4.237,4.636,4.459a1.187,1.187,0,0,0,.177-.625v-7.692A1.2,1.2,0,0,0,23.937,977.137Zm-5.311,4.742-1.155,1.028a1.444,1.444,0,0,1-1.938,0l-1.149-1.022-4.613,4.423a1.052,1.052,0,0,0,.326.054H22.9a1.049,1.049,0,0,0,.326-.054Z",
    transform: "translate(-9 -976.362)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/Mail.07d0867e.svg";
export { ForwardRef as ReactComponent };